import React from 'react'

const About = () => {
  return (
    <div name="about" className="w-full h-screen bg-[#0a192f] text-gray-300">
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="sm:text-right pb-8 pl-4">
            <p className="text-4xl font-bold inline border-b-4 border-orange-700">
              About
            </p>
          </div>
          <div></div>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <div className="sm:text-right text-4xl font-bold">
            <p>Hai, Nama saya Arlando</p>
          </div>
          <div>
            <p>
              Saya adalah seorang lulusan Teknik informatika dengan ipk 3,14
              dari Sekolah Tinggi Teknik PLN, saya memiliki total pengalaman
              kerja selama 4 tahun yaitu sebagai bancassurance specialist di BNI
              Life, Staff Operasi di Blue Bird dan owm media support di DBS
              Indonesia, selain itu pada masa kuliah saya aktif berorganisasi
              antara lain sebagai ketua divisi kewirausahaan dan saya juga
              pernah mengikuti bootcamp front end dari Sanbercode dan Myskill,
              dari pengalam kerja saya dan pelatihan yang saya ikuti saya
              memahami hal-hal yang barkaitan dengan Front end, Pemasaran ,
              system operasi dan saya orang yang jujur , mau belajar dan
              bertanggung jawab atas kerjaan atau tugas yang di berikan.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
